import * as $ from 'jquery';


    
    class MyBaumitWebClient {


        static getDashboards() {
            return $.get('/myBaumit/ajaxGetDashboards');
        }


        static sortDashboardCards(dashboardId:number, order: Array<number>) {
            var formData = new FormData();
            order.forEach(function(item){
                formData.append('cards[]', item.toString());
            });
            formData.append('dashboard_id', dashboardId.toString());
            return $.ajax({
                url: 'myBaumit/ajaxSortDashboard',
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                method: 'POST'
            });
        }
    }
        


export default MyBaumitWebClient;